"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Explanation_1 = __importDefault(require("../Explanation"));
const common_1 = require("./common");
function ParDéfautMecanism({ explanation }) {
    return (jsx_runtime_1.jsx(common_1.InfixMecanism, Object.assign({ value: explanation.valeur, dimValue: explanation.valeur.nodeValue === null }, { children: jsx_runtime_1.jsxs("p", { children: [jsx_runtime_1.jsx("strong", { children: "Par d\u00E9faut : " }, void 0),
                jsx_runtime_1.jsx(Explanation_1.default, { node: explanation.parDéfaut }, void 0)] }, void 0) }), void 0));
}
exports.default = ParDéfautMecanism;
